import {
    InviteUserDto,
    PageableResult,
    PageableSearchOptions,
    PermissionDto,
    Resource,
    UserDataDto,
    UserDto,
} from "@exibra/shared";
import { ApiService } from "../api/api.service";

class UserService extends ApiService {
    public async getUserData() {
        return this.axios.get<UserDataDto>(`/${Resource.User}/me`);
    }

    public async getUserAccess() {
        return (await this.axios.get<PermissionDto[]>(`/${Resource.User}/me/permissions`)).data;
    }

    public async getUsers(tenantId: number, options: PageableSearchOptions) {
        const res = await this.axios.get<PageableResult<UserDto>>(`/${Resource.User}`, {
            params: { tenantId, ...options },
        });

        return res.data;
    }

    public async getUser(userId: number) {
        return (await this.axios.get<UserDto>(`/${Resource.User}/${userId}`)).data;
    }

    public async inviteUser(params: InviteUserDto) {
        return this.axios.post(`/${Resource.User}/invite`, params);
    }

    public async updateUserRole(tenantId: number, userId: number, roleId: number | null) {
        return this.axios.put(`/${Resource.Tenant}/${tenantId}/user/${userId}/role`, { roleId });
    }

    public async removeUserFromTenant(tenantId: number, userId: number) {
        return this.axios.delete(`/${Resource.Tenant}/${tenantId}/user/${userId}`);
    }
}

export const userService = new UserService();
